export default function (callback) {
  if (!window.WeixinJSBridge || !window.WeixinJSBridge.invoke) {
    if (document.addEventListener) {
      document.addEventListener('WeixinJSBridgeReady', callback)
    } else if (document.attachEvent) {
      document.attachEvent("WeixinJSBridgeReady", callback)
      document.attachEvent("onWeixinJSBridgeReady", callback)
    }
  } else {
    callback()
  }
}
